document.addEventListener("click", event => {

  // If the clicked element doesn't have the right selector, bail
  if(event.target.matches(".ef-finale .ef-finale__button--microsite")){
    window.location.href = "https://www.eintracht.de/europa-league-finale-2022/";
  }else if(!event.target.matches(".ef-finale, .ef-finale *")){
    return;
  }

  // Don't follow the link
  event.preventDefault();

  const startStory = document.getElementById("ef-rts-story-open");
  if(startStory){
    startStory.classList.remove("--is-hidden");
  }

  document.querySelector(".ef-finale").classList.add("--is-hidden");
  document.body.classList.remove("--is-frozen");
  document.querySelector(".ef-content").classList.remove("ef-content--front");
  sessionStorage.setItem('finale_screen','true');
}, false);
